import clsx from 'clsx';
import dayjs from 'dayjs';
import { FC } from 'react';
import { Button } from '../../components/Button';
import { Card } from '../../components/Card';
import { ShellContent } from '../../components/Shell';
import { Spinner } from '../../components/Spinner';
import {
  setLast3Days,
  setCurrentWeek,
  setToday,
  useHistory,
  useHistoryActiveButton,
  useDateRangeValidation,
} from '../../services/history';
import { EditNote } from './EditNote';
import { EditTripType } from './EditTripType';
import styles from './History.module.css';
import { RangePicker } from './RangePicker';
import { ShowRoute } from './ShowRoute';
import { Summary } from './Summary';
import { Trip } from './Trip';
import { FormattedMessage } from 'react-intl';

interface HistoryProps {}

export const History: FC<HistoryProps> = () => {
  const data = useHistory();
  const btnState = useHistoryActiveButton();
  const { error, dateRange } = useDateRangeValidation();

  return (
    <ShellContent>
      <Card className={styles.controls}>
        <span className="light" data-testid="history-page">
          <FormattedMessage id="History" />
        </span>
        {error && (
          <div className={clsx(styles.error, 'light')}>
            <FormattedMessage id={error} />
          </div>
        )}
        <div className={styles.dateBtns}>
          <Button
            onClick={setToday}
            compact
            variant="outlined"
            className={clsx({ [styles.inactive]: btnState !== 'today' })}
          >
            <FormattedMessage id="History.Button.Today" />
          </Button>
          <Button
            onClick={setLast3Days}
            compact
            variant="outlined"
            className={clsx({ [styles.inactive]: btnState !== 'last3' })}
          >
            <FormattedMessage id="History.Button.LastThreeDays" />
          </Button>
          <Button
            onClick={setCurrentWeek}
            compact
            variant="outlined"
            className={clsx({ [styles.inactive]: btnState !== 'currentWeek' })}
          >
            <FormattedMessage id="History.Button.CurrentWeek" />
          </Button>
        </div>
        <RangePicker />
      </Card>
      {!data && (
        <div className={styles.fillCenter}>
          <Spinner />
        </div>
      )}
      {data?.trips?.length ? (
        <>
          <Summary />
          <div>
            {btnState === 'today' ? (
              <FormattedMessage id="History.Button.Today" />
            ) : btnState === 'last3' ? (
              <FormattedMessage id="History.Button.LastThreeDays" />
            ) : btnState === 'currentWeek' ? (
              <FormattedMessage id="History.Button.CurrentWeek" />
            ) : (
              `${dayjs(dateRange[0]).format('MMM D, HH:mm')} - ${dayjs(
                dateRange[1]
              ).format('MMM D, HH:mm')}`
            )}
          </div>
          {data.trips.map((trip) => (
            <Trip key={trip.flatTrip.id} id={trip.flatTrip.id} />
          ))}
        </>
      ) : null}
      <EditNote />
      <EditTripType />
      <ShowRoute />
    </ShellContent>
  );
};
